import { cn } from "@/utils/utils"

interface WaveDividerProps {
    variant?: 'warm-to-dark' | 'dark-to-warm' | 'warm-to-warm'
    className?: string
    /** Overrides the front (main) path fill so the wave can match the top color of the section it leads into. */
    fillClassName?: string
}

export default function WaveDivider({ variant = 'warm-to-dark', className, fillClassName }: WaveDividerProps) {
    return (
        <div
            className={cn(
                "pointer-events-none relative z-10 -mb-px w-full leading-[0]",
                "mt-[-60px] md:mt-[-80px] lg:mt-[-100px]",
                className,
            )}
            aria-hidden="true"
        >
            <svg
                viewBox="0 0 1440 200"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="relative block h-[60px] w-full md:h-[80px] lg:h-[100px]"
                preserveAspectRatio="none"
            >
                {variant === 'warm-to-dark' && (
                    <>
                        <path
                            d="M0,120 C120,100 240,70 360,72 C480,74 600,110 720,118 C840,126 960,100 1080,88 C1200,76 1320,82 1380,88 L1440,94 L1440,200 L0,200 Z"
                            className="fill-slate-900/40"
                        />
                        <path
                            d="M0,100 C160,130 280,90 420,78 C560,66 660,100 780,112 C900,124 1020,96 1140,84 C1260,72 1360,90 1400,100 L1440,110 L1440,200 L0,200 Z"
                            className={cn("fill-slate-900", fillClassName)}
                        />
                    </>
                )}
                {variant === 'dark-to-warm' && (
                    <>
                        <path
                            d="M0,120 C120,100 240,70 360,72 C480,74 600,110 720,118 C840,126 960,100 1080,88 C1200,76 1320,82 1380,88 L1440,94 L1440,200 L0,200 Z"
                            className="fill-amber-300/40"
                        />
                        <path
                            d="M0,100 C160,130 280,90 420,78 C560,66 660,100 780,112 C900,124 1020,96 1140,84 C1260,72 1360,90 1400,100 L1440,110 L1440,200 L0,200 Z"
                            className="fill-amber-200"
                        />
                    </>
                )}
                {variant === 'warm-to-warm' && (
                    <>
                        <path
                            d="M0,120 C120,100 240,70 360,72 C480,74 600,110 720,118 C840,126 960,100 1080,88 C1200,76 1320,82 1380,88 L1440,94 L1440,200 L0,200 Z"
                            className="fill-amber-100/50"
                        />
                        <path
                            d="M0,100 C160,130 280,90 420,78 C560,66 660,100 780,112 C900,124 1020,96 1140,84 C1260,72 1360,90 1400,100 L1440,110 L1440,200 L0,200 Z"
                            className="fill-amber-200"
                        />
                    </>
                )}
            </svg>
        </div>
    )
}
